import React from 'react';
import { Form, FormInputProps, Label } from 'semantic-ui-react';
import CustomLabel from './CustomLabel';

export interface FormInputFieldProps extends FormInputProps {
  errors?: any;
  fieldName: string;
  value: string | number;
  handleChange?: any;
  fieldLabel?: any;
  sublabel?: string;
  readOnly?: boolean;
  placeholder?: string;
  loading?: boolean;
  type?: string;
  fluid?: boolean;
  autoComplete?: string;
  icon?: string;
  iconPosition?: 'left';
  renderPointingLabel?: boolean;
  style?: React.CSSProperties;
}

const FormInputField = ({
  errors = {},
  fieldName,
  value,
  handleChange,
  fieldLabel,
  sublabel,
  readOnly,
  placeholder,
  loading,
  type,
  renderPointingLabel,
  style = {},
  ...rest
}: FormInputFieldProps) => {
  return (
    <Form.Field
      error={errors[fieldName] !== undefined}
      style={{ textAlign: 'left', ...style }}
      required={rest.required}
    >
      {rest.label === undefined && <CustomLabel label={fieldLabel} sublabel={sublabel} />}

      {errors[fieldName] && renderPointingLabel && (
        <Label color="red" pointing="below">
          {errors[fieldName]}
        </Label>
      )}
      <Form.Input
        placeholder={placeholder || fieldLabel}
        value={value}
        onChange={handleChange}
        name={fieldName}
        readOnly={readOnly}
        loading={loading}
        type={type}
        step="0.0000001"
        {...rest}
      />
    </Form.Field>
  );
};

export default React.memo(FormInputField);
